/**
 * ADM-621 - saisie monétaire des budgets, partagée entre la page Budgets et le
 * panel de gestion des catégories (drawer DRW-CATMGR) : mêmes règles de parsing
 * et même arithmétique en centimes des deux côtés.
 */

export const formatCurrency = (value: number) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(value);

/**
 * Accepte « 1 234,56 », « 1234.56 » et « 1.500 » (point-milliers français,
 * groupes de 3 chiffres : 1 500 € - le lire 1,50 € divisait le budget par
 * mille en silence). Refuse la notation scientifique : « 1e5 » dans un champ
 * monétaire est une faute de frappe, pas 100 000 €.
 */
export const parseAmount = (raw: string): number | null => {
  let normalized = raw.replace(/\s/g, "");
  if (normalized === "") return 0;
  // Points strictement en séparateurs de milliers (1.500 / 1.500.000, avec ou
  // sans décimales en virgule) : on les retire avant de traiter la virgule.
  if (/^\d{1,3}(?:\.\d{3})+(?:,\d+)?$/.test(normalized)) {
    normalized = normalized.replace(/\./g, "");
  }
  normalized = normalized.replace(",", ".");
  if (!/^\d+(?:\.\d+)?$/.test(normalized)) return null;
  const value = Number(normalized);
  return Number.isFinite(value) ? value : null;
};

/** L'API compare en BigDecimal(12,2) : toute la jauge se calcule en centimes. */
export const toCents = (value: number) => Math.round(value * 100);
export const fromCents = (cents: number) => cents / 100;
